import { ThumbnailItem } from '@ntv360/component-pantry';

export const PLAYER_STATUS = [
    {
        label: 'Pi Status',
        value: 'ONLINE',
    },
    {
        label: 'Player Status',
        value: 'ONLINE',
    },
    {
        label: 'TV Status',
        value: 'OFFLINE',
    },
    {
        label: 'Display Status',
        value: 'OFFLINE',
    },
    {
        label: 'Last Startup',
        value: 'Nov 04, 2024 12:03 AM',
    },
    {
        label: 'Last Disconnect',
        value: 'Nov 04, 2024 09:52 AM',
    },
    {
        label: 'Last Update',
        value: 'Nov 04, 2024 12:02 AM',
    },
    {
        label: 'Anydesk',
        value: 'Nov 04, 2024 12:03 AM',
    },
    {
        label: 'Anydesk Password',
        value: 'Nov 04, 2024 09:52 AM',
    },
    {
        label: 'TV Brand',
        value: 'Nov 04, 2024 12:02 AM',
    },
];

export const SCREEN_INFO = {
    screenName: "331-Fin's Japanese Sushi & Grill",
    screenTemplate: 'NCT Standard Template',
    screenPlaylist: [
        {
            label: 'Background',
            value: 'D.219 4-BG',
        },
        {
            label: 'Main',
            value: 'Programmatic Do Not Convert to V2',
        },
        {
            label: 'Vertical',
            value: 'D.219 2-PH? Saigon',
        },
        {
            label: 'Horizontal',
            value: 'D.219 3-Banner',
        },
    ],
};

export const SYSTEM_INFO = [
    {
        label: 'Connection Status',
        value: 'GOOD',
    },
    {
        label: 'Connection Type',
        value: 'WLAN0',
    },
    {
        label: 'Download Speed',
        value: '25.43 Mbps',
    },
    {
        label: 'Upload Speed',
        value: '21.40 Mbps',
    },
    {
        label: 'Storage',
        value: '19.14 GB free of 29 GB',
    },
    {
        label: 'RAM/Memory',
        value: '1 GB',
    },
    {
        label: 'Player Version',
        value: 'Version 2',
    },
    {
        label: 'Server Version',
        value: '2.9.2',
    },
    {
        label: 'UI Version',
        value: '3.0.42',
    },
    {
        label: 'Pi Version',
        value: 'Raspberry Pi 3 Model B Rev 1.2',
    },
    {
        label: 'Chromium Version',
        value: '92.0.415.98',
    },
    {
        label: 'Current IP',
        value: '119.93.171.229',
    },
    {
        label: 'Previous IP',
        value: 'N/A',
    },
    {
        label: 'Mac Address',
        value: 'b8:27:eb:7e:ca:06',
    },
];
